import React from 'react';
import * as componentStyle from './caseStudySlider.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { GatsbyImageInterface } from '../../../../../interface/image.interface';
import { useLocation } from "@reach/router";



interface ImageInterface {
  image: GatsbyImageInterface | null;
  altText: string | null;
}
interface CaseStudiesBannerInterface {
  heading: string | null;
  sectionImage: ImageInterface | null;
}
interface CaseStudiesV2Interface {
  caseStudiesBanner: CaseStudiesBannerInterface | null;
}
interface CaseStudyV2NodeInterface {
  id: string | null;
  title: string | null;
  slug: string | null;
  caseStudiesV2: CaseStudiesV2Interface | null;
}
interface CaseStudyEdgeInterface {
  node: CaseStudyV2NodeInterface | null;
}
interface AllCaseStudyV2Interface {
  edges: CaseStudyEdgeInterface[] | null;
}
interface CaseStudyQueryInterface {
  allWpCaseStudyV2: AllCaseStudyV2Interface | null;
}

export default function CaseStudySlider() {

  const caseStudiesData: CaseStudyQueryInterface | null = useStaticQuery(graphql`
    query UpcomingCaseStudies {
      allWpCaseStudyV2(sort: {date: DESC}, limit: 5) {
        edges {
          node {
            id
            title
            slug
            caseStudiesV2 {
              caseStudiesBanner {
                heading
                sectionImage {
                  altText
                  image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData (
                          quality: 90
                          formats: [AUTO, WEBP, AVIF]
                          layout: CONSTRAINED
                          placeholder: BLURRED
                        )
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const location = useLocation();
  const currentPath = location.pathname.split('/').filter(Boolean).pop();
  const filteredCaseStudyData = caseStudiesData?.allWpCaseStudyV2?.edges?.filter((item) => item?.node?.slug !== currentPath);

  return (
    <>
      {!!filteredCaseStudyData?.length && (
        <div className={componentStyle.caseStudySlider__carousel}>
          <Swiper
            speed={600}
            grabCursor={true}
            slidesPerView={1.2}
            spaceBetween={19}
            breakpoints={{
              1600: {
                slidesPerView: 2.5,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 2.2,
                spaceBetween: 30,
              },
              768: {
                slidesPerView: 1.5,
                spaceBetween: 30,
              },
            }}
          >
            {filteredCaseStudyData.map((context, index) => (
              <SwiperSlide key={`swiperSlide${index}`}>
                <div className={componentStyle.caseStudySlider__swiperCard}>
                  <div className={componentStyle.caseStudySlider__imageBox}>
                    <Link to={`/case-study/${context?.node?.slug}`} className={componentStyle.caseStudySlider__imageLink}>
                      {context?.node?.caseStudiesV2?.caseStudiesBanner?.sectionImage?.image && (
                        <GatsbyImage
                          image={getImage(context.node.caseStudiesV2.caseStudiesBanner.sectionImage.image.localFile) as IGatsbyImageData}
                          alt={context?.node.caseStudiesV2.caseStudiesBanner.sectionImage.altText || 'N/A'}
                          className={componentStyle.caseStudySlider__image}
                        />
                      )}
                    </Link>
                  </div>

                  {context.node?.caseStudiesV2?.caseStudiesBanner?.heading && (
                    <div className={componentStyle.caseStudySlider__titleArea}>
                      <div className={componentStyle.caseStudySlider__title}>
                        <Link 
                          to={`/case-study/${context?.node?.slug}`} 
                          className={componentStyle.caseStudySlider__titleLink}
                        >
                          {context.node.caseStudiesV2.caseStudiesBanner.heading?.replace(/<[^>]*>?/gm, '')}
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  )
}
